export const NavBarHeight = "50px";

export const apiUrl = process.env.REACT_APP_API_URL;
export const aszfDocUrl = process.env.REACT_APP_ASZF;
export const adatkezelesDocUrl = process.env.REACT_APP_ADATKEZELESI_TAJEKOZTATO;